
import '../../App.css';
import { Link } from 'react-router-dom';
import logo from '../../images/logo-dark.png'
import { FaTwitter, FaInstagram } from "react-icons/fa";
const Footer = () => {
    return (
        <footer class="py-3">
            <nav className="container flex flex-row justify-between items-center py-4 mt-4 sm:mt-12">
                <div className='py-1'>
                    <Link to="/"><img src={logo} alt="Logo" className="cursor-pointer w-12 h-12" /></Link>
                </div>
                <ul class="flex text-white uppercase gap-12 text-xs">
                    <li className='cursor-pointer text-primary'><Link to="/privacy">Privacy Policy</Link></li>
                </ul>
                <div className='flex flex-row gap-12'>
                    <div className='flex flex-1 justify-end'>
                        <a href="https://twitter.com/owaa_app" target="_blank" rel="noreferrer"><FaTwitter className='cursor-pointer text-primary' style={{ fontSize: '20px', color: "#0753AB" }} /></a>
                    </div>
                    <div className='flex flex-1 justify-end'>
                        <a href="https://www.instagram.com/owaa_app/" target="_blank" rel="noreferrer"><FaInstagram className='cursor-pointer text-primary' style={{ fontSize: '20px' }} /></a>
                    </div>
                </div>
            </nav>
        </footer>
    );
}

export default Footer;
